import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import './Pagination.pcss';
import { useEffect, useState } from 'react';
import { throttle } from '../../../../../utils/throttle';
import { getURLParam, setURLParam } from '../../utils/url-params';
import { PaginationPageButtons } from './PaginationPageButtons';
import { useStoreContext } from '../../hooks/useStoreContext';
import { getPagesAmount } from '../../utils/get-pages-amount';
const initialPaginationState = {
    pagesAmount: 1,
    currentPage: 1,
    itemsAmount: 0,
    itemsPerPage: 0,
};
export const PaginationControllers = ({ element, URLName }) => {
    const [pagination, setPagination] = useState(initialPaginationState);
    const { filteredItems } = useStoreContext();
    useEffect(() => {
        const updatePagination = () => {
            const itemsAmount = filteredItems.show.length;
            const { pagesAmount, itemsAmountPerPage } = getPagesAmount(itemsAmount);
            const pageParam = Number(getURLParam(URLName) || 1);
            const currentPage = Math.max(1, Math.min(pageParam, pagesAmount));
            setPagination({
                pagesAmount,
                currentPage,
                itemsAmount,
                itemsPerPage: itemsAmountPerPage,
            });
        };
        updatePagination();
        const throttledUpdate = throttle(updatePagination, 300);
        window.addEventListener('resize', throttledUpdate);
        return () => {
            window.removeEventListener('resize', throttledUpdate);
        };
    }, [filteredItems.show.length]);
    useEffect(() => {
        if (JSON.stringify(pagination) === JSON.stringify(initialPaginationState))
            return;
        setURLParam(URLName, String(pagination.currentPage));
        const offset = (pagination.currentPage - 1) * pagination.itemsPerPage;
        const endOffset = offset + pagination.itemsPerPage;
        const items = filteredItems.show;
        items.forEach((item, index) => {
            item.toggleAttribute('hidden', index < offset || index >= endOffset);
        });
    }, [pagination, filteredItems.show.length]);
    if (pagination.pagesAmount <= 1)
        return _jsx(_Fragment, {});
    const scrollToElement = () => {
        setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
        });
    };
    const onPageButtonClick = (page) => {
        return () => {
            setPagination((prev) => ({ ...prev, currentPage: page }));
            scrollToElement();
        };
    };
    return (_jsx("div", { className: "new-store__pagination store-pagination", children: _jsx("div", { className: "store-pagination__controlls", children: _jsx("div", { className: "store-pagination__pages-list", children: _jsx(PaginationPageButtons, { onPageButtonClick: onPageButtonClick, pagination: pagination }) }) }) }));
};
